import React from 'react';

/**
 * Superficie elevada generica (radius-card + shadow-raised). `padded=false` para
 * cuando el contenido interno ya trae su propio padding (p.ej. una tabla).
 */
function Card({ padded = true, className = '', children, ...rest }) {
  return (
    <div className={`sgc-card ${padded ? 'sgc-card--padded' : ''} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export default Card;
